import { device } from 'constants/device';

import styled from 'styled-components';

export const LinksSection = styled.div``;
export const LinksSectionRow = styled.div`
  display: flex;
  width: 574px;
  justify-content: space-between;
  margin-bottom: 1.6rem;
  @media ${device.laptop} { 
    max-width: 574px;
    justify-content: flex-start;
    width: 100%;
  }
`;
export const LinksDescription = styled.span`
  width: 86px;
  font-size: 1.8rem;
  line-height: 1.6;
  font-weight: 500;
  color: ${({ theme }) => theme.system.black};
  @media ${device.laptop} { 
    font-size: 1.4rem;
    width: 67px;
    flex: 1 1 97px;
    max-width: 97px;
  }
`;

export const LinkWrapper = styled.div`
  width: 415px;
  @media ${device.laptop} {  
    width: auto;
    min-width: 197px;
    max-width: 415px;
    flex: 1 1 197px;
  }
`;
